import axios from "axios";
import * as types from "../mutation-types";
import api from "../../api/api";

export const state = {
    listEmployeeTypeWorks: [],
    listEmployeeTypeWork: {},
    projects: [],
    pagination: {
      from: 0,
      to: 0,
      totalPage: 0,
      path: "",
      currentPage: 0,
      totalRecord: 0,
      perPage: 0
    },
    updateTypeWork: null
}

//getters
export const getters = {
    listEmployeeTypeWorks: state => state.listEmployeeTypeWorks,
    pagination: state => state.pagination,
    listEmployeeTypeWork: state => state.listEmployeeTypeWork,
    updateTypeWork: state => state.updateTypeWork,
    projects: state => state.projects
}

//mutations
export const mutations = {
  [types.TYPE_WORK.LIST_TYPE_WORK_EMPLOYEE](state, data) {
    state.listEmployeeTypeWorks = data.employees;
    state.pagination.from = data.employees.from;
    state.pagination.to = data.employees.to;
    state.pagination.totalPage = data.employees.last_page;
    state.pagination.path = data.employees.path;
    state.pagination.currentPage = data.employees.current_page;
    state.pagination.totalRecord = data.employees.total;
    state.pagination.perPage = data.employees.per_page;
  },
  [types.TYPE_WORK.UPDATE_TYPE_WORK_EMPLOYEE](state, data) {
    state.UPDATE_TYPE_WORK_EMPLOYEE = data;
  },
  [types.TYPE_WORK.PROJECT_REMOTE](state, data) {
    state.projects = data;
  }
};

// actions
export const actions = {
    async fetchTypeWorkEmployee({ commit }, payload) {
        const response = await axios.get(api.LIST_TYPE_WORK_EMPLOYEE, {
          params: {
            per_page: payload.optionPage,
            page: payload.currentPage,
            employee: payload.name,
            department_code: payload.divisionCode,
            project_id: payload.projectName
          }
        });
        commit(types.TYPE_WORK.LIST_TYPE_WORK_EMPLOYEE, response.data);
      },
    async updateTypeWork({ commit }, params) {
        const response = await axios.post(api.UPDATE_TYPE_WORK_EMPLOYEE, params);
        commit(types.TYPE_WORK.UPDATE_TYPE_WORK_EMPLOYEE, response.data);
    },
    async projects({ commit }) {
        const response = await axios.get(api.LIST_PROJECT_REMOTE);
        commit(types.TYPE_WORK.PROJECT_REMOTE, response);
      },
}